import { Box, Heading } from "@chakra-ui/react";
import { PageBlockBreakpoint } from "lib/gcms";

export const PodcastPreview = (props: PageBlockBreakpoint) => {
  return (
    <Box
      as="section"
      py="5"
      bg={props.bg}
      color={props?.color}
      textAlign="left"
      sx={{
        "h2 span": {
          fontWeight: "lighter",
        },
      }}
    >
      <Box
        maxW={{ base: "xl", md: "7xl" }}
        mx="auto"
        px={{ base: "6", md: "8" }}
      >
        <Heading
          size="2xl"
          letterSpacing="tight"
          mt="5"
          mb="4"
          fontWeight="extrabold"
          lineHeight="normal"
        >
          {props.title}
        </Heading>
        <Box pt="5" justifySelf="center" width="full">
          <iframe
            src="https://share.transistor.fm/e/climate-clear/playlist"
            width="100%"
            height="390"
            seamless
            id="podcast-player"
          />
        </Box>
      </Box>
    </Box>
  );
};
